import { define, ui } from '@owenscorning/pcb.alpha';

import Renderer from '../../../../OC/PageBuilder/CalculatorFiberglass.jsx';

export default define`Fiberglass Calculator`('0.0.1')({
  thumbnail: ui`Modules/Page/Thumbnails/FiberglassCalculator`,
  category: ui`Modules/Categories/Page/Prebuilt`,
  view: ({ value }) => <Renderer {...value} />,
  edit: {},
});
